(function (root) {
  'use strict';
  if (!root.document) return;
  if (root.__kmCartDrawerUiController) {
    root.__kmCartDrawerUiController.init();
    return;
  }

  var currentDrawer = null;
  var cleanupCurrent = null;

  function money(value) {
    if (root.theme && root.theme.Currency && root.theme.settings) {
      return root.theme.Currency.formatMoney(value, root.theme.settings.moneyFormat);
    }
    return '$' + (Number(value || 0) / 100).toFixed(2);
  }

  function render(drawer, cart) {
    if (!cart) return;
    var count = Number(cart.item_count || 0);
    var heading = drawer.querySelector('[data-cart-heading]');
    if (heading) heading.textContent = 'Cart · ' + count;
    var checkoutPrice = drawer.querySelector('[data-km-cart-checkout-price]');
    if (checkoutPrice) checkoutPrice.textContent = money(cart.total_price || 0);
    var savings = drawer.querySelector('[data-km-cart-savings]');
    var savingsValue = drawer.querySelector('[data-km-cart-savings-value]');
    var lines = Array.from(drawer.querySelectorAll('[data-km-cart-line]'));
    var saleSavings = (cart.items || []).reduce(function (sum, item) {
      var properties = item.properties || {};
      if (properties._km_cart_gift === 'true' || String(properties._uc_is_gift) === '1' || properties._uc_pick_section) return sum;
      var original = Number(item.original_price || 0);
      if (original <= 0) return sum;
      var line = lines.find(function (line) { return line.dataset.key === item.key; })
        || lines.find(function (line) { return String(line.dataset.kmCartVariantId) === String(item.variant_id || item.id); });
      var regular = line ? Number(line.dataset.kmCartComparePrice || 0) : original;
      return sum + Math.max(0, regular - original) * Number(item.quantity || 0);
    }, 0);
    var saved = saleSavings + Math.max(0, Number(cart.total_discount || 0), Number(cart.original_total_price || 0) - Number(cart.total_price || 0));
    var hasCodes = (cart.discount_codes || []).some(function (code) { return code.applicable; });
    if (savings) savings.hidden = saved <= 0 && !hasCodes;
    if (savingsValue) savingsValue.textContent = '-' + money(saved);
  }

  function fitVariants(drawer) {
    var canvas = root.document.createElement('canvas');
    var context = canvas.getContext('2d');
    drawer.querySelectorAll('[data-km-cart-variant-select]').forEach(function (select) {
      var style = root.getComputedStyle(select);
      context.font = style.fontStyle + ' ' + style.fontWeight + ' ' + style.fontSize + ' ' + style.fontFamily;
      var text = select.options[select.selectedIndex]?.textContent || '';
      var width = Math.ceil(context.measureText(text).width) + parseFloat(style.paddingLeft) + parseFloat(style.paddingRight) + 2;
      var available = select.parentElement.clientWidth;
      select.style.width = (available > 0 ? Math.min(width, available) : width) + 'px';
    });
  }

  function init() {
    var drawer = root.document.getElementById('CartDrawer');
    if (!drawer || drawer === currentDrawer) return;
    if (cleanupCurrent) cleanupCurrent();
    currentDrawer = drawer;
    var readPromise;

    function readCart() {
      if (readPromise) return readPromise;
      var url = drawer.dataset.cartUrl || '/cart.js';
      readPromise = root.fetch(url, {credentials: 'same-origin', cache: 'no-store'})
        .then(function (response) { if (!response.ok) throw new Error('Unable to load cart.'); return response.json(); })
        .then(function (cart) { render(drawer, cart); return cart; })
        .catch(function () { return null; })
        .finally(function () { readPromise = null; });
      return readPromise;
    }

    function onCartUpdated(event) {
      if (event.detail && event.detail.cart) render(drawer, event.detail.cart);
      else readCart();
    }

    function onRendered() { fitVariants(drawer); readCart(); }
    function onResize() { fitVariants(drawer); }
    function onChange(event) {
      if (event.target.matches('[data-km-cart-variant-select]')) fitVariants(drawer);
    }
    function onRemove(event) {
      var remove = event.target.closest('[data-km-cart-remove]');
      if (!remove || !drawer.contains(remove)) return;
      var nativeCart = remove.closest('form')?.kmCartForm;
      if (!nativeCart) return;
      event.preventDefault();
      var line = remove.closest('[data-km-cart-line]');
      if (!line) return;
      if (line.classList.contains('is-loading')) return;
      remove.setAttribute('aria-busy', 'true');
      remove.setAttribute('aria-disabled', 'true');
      root.document.dispatchEvent(new root.CustomEvent('cart:quantity' + nativeCart.namespace, {
        detail: [line.dataset.key, 0, line, line.dataset.line]
      }));
    }

    root.document.addEventListener('cart:updated', onCartUpdated);
    root.document.addEventListener('cart:rendered', onRendered);
    root.document.addEventListener('drawerOpen.CartDrawer', onRendered);
    root.addEventListener('resize', onResize);
    drawer.addEventListener('change', onChange);
    drawer.addEventListener('click', onRemove);
    cleanupCurrent = function () {
      root.document.removeEventListener('cart:updated', onCartUpdated);
      root.document.removeEventListener('cart:rendered', onRendered);
      root.document.removeEventListener('drawerOpen.CartDrawer', onRendered);
      root.removeEventListener('resize', onResize);
      drawer.removeEventListener('change', onChange);
      drawer.removeEventListener('click', onRemove);
      if (currentDrawer === drawer) currentDrawer = null;
    };
    fitVariants(drawer);
    if (root.document.fonts) root.document.fonts.ready.then(function () { if (currentDrawer === drawer) fitVariants(drawer); });
    readCart();
  }

  root.__kmCartDrawerUiController = {init: init};
  root.document.addEventListener('shopify:section:load', init);
  root.document.addEventListener('shopify:section:unload', function (event) {
    if (currentDrawer && event.target && event.target.contains && event.target.contains(currentDrawer) && cleanupCurrent) cleanupCurrent();
  });
  init();
})(typeof window !== 'undefined' ? window : globalThis);
